













































































import { Component, Vue } from "vue-property-decorator";


/**
 * Utils
 */
import classes from "@/config/wow/classes";
import * as imageLinks from "@/config/image-links";
import { getLocaleStringFromDateString, differenceInDaysBetweenDates, getMaxDate, smartDisplayDays } from "@/utils/date-helpers";


const computeDurationFromRegistration = (x: any) => {
	const theDate = new Date("10/16/2017");
	return differenceInDaysBetweenDates(getMaxDate([new Date(Date.parse(x.createdAt)), theDate]), new Date());
};
const computeConnectionTimesPerDay = (x: any) => {
	return x.connectionTimes / computeDurationFromRegistration(x);
};

/**
 * Components
 */

/**
 * API
 */
import adminAPI from "@/api/admin";
import { normalizeString } from "@/utils/string-helpers";
import StatCard from "@/components/admin/components/StatCard.vue";
import DataFetcher from "@/components/_global/DataFetcher.vue";

/**
 * Types
 */


/**
 * VueX Modules
 */

/**
 * Admin characters list page.
 */
@Component({
	components: {
		DataFetcher,
		StatCard
	}
})
export default class CharactersListPage extends Vue {
	/// Injections
	classes = classes;
	getLocaleStringFromDateString = getLocaleStringFromDateString;
	differenceInDaysBetweenDates = differenceInDaysBetweenDates;
	smartDisplayDays = smartDisplayDays;
	imageLinks = imageLinks;

	/// Attributes
	now = new Date();
	isLoading = false;

	// Filters
	searchField = "";
	displaySubscribedUsers = false;

	// Pagination
	page = 1;
	pageCount = 0;
	// Table
	users: any[] | null = null;
	subscribedUsers: any[] | null = null;

	get headers() {
		const result = [
			{
				text: this.$t("user.battle_tag"),
				value: "battleTag",
				align: "left"
			},
			{
				text: this.$t("user.characters"),
				value: "characters",
				align: "left",
				sortable: false
			},
			{
				text: this.$t("user.created_at"),
				value: "createdAt",
				align: "left"
			},
			{
				text: this.$t("user.updated_at"),
				value: "updatedAt",
				align: "left"
			},
			{
				text: this.$t("user.connection_times"),
				value: "connectionTimes",
				align: "left"
			},
			{
				text: this.$t("user.mean_connection_times_per_day"),
				value: "meanConnectionTimesPerDay",
				align: "left"
			}];

		if (this.displaySubscribedUsers) {
			result.push({
				text: this.$t("user.premium_plan"),
				value: "premiumPlan",
				align: "left"
			});
		}

		result.push({
			text: this.$t("user.discord"),
			value: "discord",
			align: "left"
		});

		return result;
	}

	get displayedUsers() {
		const users = this.displaySubscribedUsers ? this.subscribedUsers : this.users;
		if (users == null) {
			return [];
		}

		const searchField = normalizeString(this.searchField);
		return users
			.filter(u =>
				u.battleTag && normalizeString(u.battleTag).includes(searchField)
				|| u.discord && normalizeString(u.discord).includes(searchField)
				|| u.characters.find((c: any) => c.name && normalizeString(c.name).includes(searchField)) != null
				|| u.characters.find((c: any) => c.guildName && normalizeString(c.guildName).includes(searchField)) != null)
			.map(u => ({
				...u,
				characters: u.characters,
				meanConnectionTimesPerDay: computeConnectionTimesPerDay(u).toFixed(2)
			}));
	}

	/// Methods
	async created() {
	}

	async fetch() {
		this.users = await adminAPI.getUsers();
		this.subscribedUsers = await adminAPI.getSubscribedUsers();
	}

}
